// extracted by mini-css-extract-plugin
export default {"resume":"Resume_resume__zqLKr","resumeEducationProjects":"Resume_resumeEducationProjects__LR4oH"};